/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_IVA_DDJJ_AFIP_ITEM = {
  id: 'sub_nav_0',
  screenId: 'tax-iva-ddjj-mis-comprobantes',
  label: 'DDJJ — Mis Comprobantes',
  description: 'Conciliar exportación AFIP con facturas del sistema.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Subís el archivo de «Mis Comprobantes» de AFIP y el sistema lo compara con tus facturas de venta y compra para detectar diferencias antes de la DDJJ.',
      },
      {
        title: 'Paso 1 — Subir archivo',
        bullets: [
          'Elegí el archivo exportado desde AFIP (Mis Comprobantes).',
          'Tocá el botón de procesar / conciliar.',
        ],
      },
      {
        title: 'Paso 2 — Revisar resultados',
        bullets: [
          'Resumen: total declaraciones, coincidencias exactas, parciales y sin match.',
          'Podés filtrar por tipo de coincidencia y ver detalle en una ventana.',
          'Usalo para encontrar comprobantes faltantes o con datos distintos al sistema.',
        ],
      },
    ],
  },
}
